import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() pagination: any;
  @Input() page=0;
  @Output() next = new EventEmitter<any>();
  @Output() prev = new EventEmitter<any>();
  @Output() num = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  
}
